import { Pipe, PipeTransform, inject } from '@angular/core';
import { IconKey } from '../../../whitelabel/icon-key.enum';
import { LanguageService } from '../../core/services/language.service';
import { MaintenanceCategory } from '../../pages/maintenance/enums/maintenance-category.enum';
import { IconProviderService } from '../../whitelabel/services/icon-provider.service';

@Pipe({
  name: 'maintenanceCategory',
  standalone: true,
})
export class MaintenanceCategoryPipe implements PipeTransform {
  private languageService = inject(LanguageService);
  private iconProviderService = inject(IconProviderService);

  transform(value: MaintenanceCategory, format: 'text' | 'icon'): string {
    let icon;
    switch (value) {
      case MaintenanceCategory.REMINDER:
        icon = this.iconProviderService.getIcon(IconKey.MaintenanceCategoryReminder);
        return this.iconOrText(format, icon, this.translate('general.reminder'));
      case MaintenanceCategory.CHECK:
        icon = this.iconProviderService.getIcon(IconKey.MaintenanceCategoryCheck);
        return this.iconOrText(format, icon, this.translate('general.inspection.s'));
      case MaintenanceCategory.CHECK_AND_REPAIR:
        icon = this.iconProviderService.getIcon(IconKey.MaintenanceCategoryCheckAndRepair);
        return this.iconOrText(format, icon, this.translate('general.maintenance.s'));
      case MaintenanceCategory.STAND_ALONE:
        icon = this.iconProviderService.getIcon(IconKey.MaintenanceCategoryStandalone);
        return this.iconOrText(format, icon, this.translate('general.standalone.s'));
      default:
        return '';
    }
  }

  private iconOrText(format: 'text' | 'icon', icon: string, text: string) {
    return format === 'text' ? text : icon;
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
